// @flow
// eslint-disable-next-line ta-code-conventions/has-matching-test,ta-code-conventions/has-matching-storydoc
import * as React from 'react';
import { Query } from 'react-apollo';
import Logging from '@ta/common.logging';

/** An intentionally poorly-chosen name was chosen to dissuade people from using this.
 *
 * Use this until the partialRefetch option is available in the react-apollo 2.2.0 (a.k.a. after social launch)
 *
 * Also use this until onError is properly implemented in react-apollo
 *
 */

/** See https://www.apollographql.com/docs/react/essentials/queries.html#props */
type ExternalProps = any;

type Props = {|
  /** The query result. See https://www.apollographql.com/docs/react/essentials/queries.html#render-prop */
  result: any,
  /** Render prop that uses the above result */
  children: React.Node,
  /** The fetchPolicy. See https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-config-options-fetchPolicy */
  fetchPolicy: string,
  /** The query document. See DocumentNode. */
  query: any,
  /** Whether the query should be skipped */
  skip?: boolean,
  /** An event to fire when an error is set. A workaround since onError isn't properly implemented in react-apollo */
  onError: any => React.Node,
|};
/** @deprecated
 *  Unfortunately, we deprecate this component before it was born :(
 * */
class PartialRefetchHandlerUntilReactApollo220Release extends React.Component<Props> {
  componentDidMount() {
    const { result: currentResult, onError } = this.props;
    if (onError && currentResult.error) {
      onError(currentResult.error);
    }
  }

  shouldComponentUpdate({ result, fetchPolicy, query, skip }: Props) {
    const { loading, error, data, refetch } = result;
    if (
      !skip &&
      fetchPolicy !== 'cache-only' &&
      !loading &&
      !error &&
      (!data || Object.keys(data).length === 0)
    ) {
      if (
        query.definitions &&
        query.definitions[0] &&
        query.definitions[0].name &&
        query.definitions[0].name.value
      ) {
        Logging.error(
          `The query was underfetched:${
            query.definitions[0].name.value
          }. If the query is stateful, then this will cause unexpected bugs downstream.`,
        );
      }
      refetch();
      return false;
    }
    return true;
  }

  componentDidUpdate({ result: previousResult }: Props) {
    const { result: currentResult, onError } = this.props;
    if (onError && !previousResult.error && currentResult.error) {
      onError(currentResult.error);
    }
  }
  render() {
    return this.props.children;
  }
}

const QueryWithPartialRefetchUntilReactApollo220Release = ({
  onError,
  ...props
}: ExternalProps) => (
  <Query {...props}>
    {result => (
      <PartialRefetchHandlerUntilReactApollo220Release
        query={props.query}
        skip={props.skip}
        fetchPolicy={props.fetchPolicy}
        result={result}
        onError={onError}
      >
        {props.children(result)}
      </PartialRefetchHandlerUntilReactApollo220Release>
    )}
  </Query>
);

export default QueryWithPartialRefetchUntilReactApollo220Release;
